import { captureTokensInStringRegex, tokenizeByRegex } from '../utils';

export const separateLayers = (layersStr: string) => {
  const resolveToken = (tokenValue: string): string => {
    const token = tokenValue.match(captureTokensInStringRegex)?.[0];
    if (token) {
      return resolveToken(tokenValue.replace(token, tokenMap.get(token)));
    }
    return tokenValue;
  };

  const regexToTokenizeBy = /([A-Za-z-]+\([^()]+\))/g;
  const { tokenMap, remainingExpression: tokenizedLayersStr } = tokenizeByRegex(
    layersStr,
    regexToTokenizeBy,
  );
  const tokenizedLayers = tokenizedLayersStr.split(',');
  const layers = tokenizedLayers.map(layer => resolveToken(layer.trim()));
  return layers;
};
